import { render, staticRenderFns } from "./SchedulePhysician.vue?vue&type=template&id=7ddf2af8"
import script from "./SchedulePhysician.vue?vue&type=script&lang=js"
export * from "./SchedulePhysician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports